// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_to-object.js
// module id = 1391
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16